import { Dispatch } from '@reduxjs/toolkit';
import { setPublications } from '../actions';
import { AppState } from '../store';

export function getPublications(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/Publication/GetAll`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const publications = await data.json();
      dispatch(setPublications(publications));
    } catch (error) {
      console.error(error);
    }
  };
}
